import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ClpFormComponent } from './form.component';

@NgModule({
  declarations: [ClpFormComponent],
  imports: [
    CommonModule,
  ],
  providers: [],
  exports: [
    ClpFormComponent
  ],
})
export class ClpFormModule { }
